/**
 * @file Selfie Swap Header.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Header from '../../../../components/global/Header';
import Logo from '../../../../components/global/Logo';
import MobileHeaderSupportButton from '../../../../components/product/MobileHeaderSupportButton';

const propTypes = {
  openModal: PropTypes.func.isRequired,
};

const SelfieSwapHeader = ({ openModal }) => (
  <Fragment>
    <Header>
      <div className="site-brand">
        <Logo />
      </div>

      <MobileHeaderSupportButton className="ml-auto" openModal={openModal} />
    </Header>
  </Fragment>
);

SelfieSwapHeader.propTypes = propTypes;

export default SelfieSwapHeader;
